import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initImageFadeIn } from "./lib/imageFadeIn";
import { scheduleMonitoring } from "./monitoring/sentry";

// Auto-recover from stale chunk references after a redeploy.
// When the browser holds an old index.js that points to chunk filenames
// which no longer exist, dynamic imports throw "Importing a module script failed".
// Reload once to fetch the new index + chunks.
const RELOAD_KEY = "__lovable_chunk_reload";
function handleChunkError(message: string) {
  if (!/Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module/i.test(message)) {
    return;
  }
  if (sessionStorage.getItem(RELOAD_KEY)) return;
  sessionStorage.setItem(RELOAD_KEY, "1");
  window.location.reload();
}
window.addEventListener("error", (e) => handleChunkError(e.message || ""));
window.addEventListener("unhandledrejection", (e) => {
  const msg = (e.reason && (e.reason.message || String(e.reason))) || "";
  handleChunkError(msg);
});
// Clear the guard once the app actually mounts successfully.
queueMicrotask(() => {
  setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), 5000);
});

initImageFadeIn();
createRoot(document.getElementById("root")!).render(<App />);

// Observabilidad: el SDK se carga cuando el navegador está ocioso,
// después del primer render — cero impacto en el arranque.
scheduleMonitoring();
